import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, BookOpen, Zap } from 'lucide-react';
import { CTAButton, CHECKOUT_URL, PRICE_EUR } from './Shared';
const heroImage = {
  src: 'https://cdn.magicpatterns.com/uploads/kRxis8sY3u56Cu6H4Fb11R/ChatGPT_Image_21_sept_2026,_16_20_24.png',
  alt: 'Mega Pack Qi Gong: i 3 volumi principali e i 5 bonus pratici inclusi'
};
const trustRowOne = [{
  icon: ShieldCheck,
  label: 'Garanzia 7 giorni'
}, {
  icon: Lock,
  label: 'Pagamento sicuro'
}, {
  icon: BookOpen,
  label: 'Materiale in PDF'
}];
const trustRowTwo = [{
  icon: Zap,
  label: 'Accesso immediato'
}];
export const Hero = () => {
  return <header className="relative overflow-hidden" data-id="element-98" data-mp="sd4bh249r8oh">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-99" data-mp="nb6l7nxgbdm1">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[760px] h-[760px] max-w-[130vw] rounded-full bg-brand-goldLight/25 blur-[150px]" data-id="element-100" data-mp="3d33eqyadctkr" />
        <div className="absolute top-16 right-[3%] font-display text-[96px] md:text-[170px] leading-none text-brand-purpleDark/[0.06] select-none animate-float-soft" style={{
        animationDelay: '0.8s'
      }} data-id="element-101" data-mp="3j898df6ywfql">
          氣
        </div>
        <div className="absolute bottom-16 left-[3%] font-display text-[80px] md:text-[140px] leading-none text-brand-purpleDark/[0.05] select-none animate-float-soft" style={{
        animationDelay: '2s'
      }} data-id="element-102" data-mp="39cpc2rohrf1b">
          和
        </div>
        <div className="hidden lg:block absolute top-[18%] left-[4%] w-56 h-56 rounded-full border border-brand-gold/25" data-id="element-103" data-mp="359j9pv4i2804" />
        <div className="hidden lg:block absolute bottom-[12%] right-[4%] w-48 h-48 rounded-full border border-brand-purpleDark/10" data-id="element-104" data-mp="2qloeo830rrjv" />
      </div>

      {/* Above the fold: headline, mockup and CTA — no scroll needed on mobile */}
      <motion.div initial={{
      opacity: 0,
      y: 14
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7
    }} className="relative z-10 mx-auto flex min-h-[calc(100svh-44px)] w-full max-w-6xl flex-col items-center justify-center gap-[0.7vh] px-3 pt-1 pb-1.5 text-center sm:px-6 md:min-h-0 md:gap-5 md:py-14" data-id="element-105" data-mp="2lkqy1zxnr5kh">
        <p className="shrink-0 font-seal text-[13px] md:text-base uppercase tracking-seal text-brand-goldDark underline decoration-brand-gold/70 decoration-1 underline-offset-4" data-id="element-106" data-mp="id050tel8app">
          Lumen Akasha
        </p>

        {/* Exactly two lines, at every width */}
        <h1 className="shrink-0 font-display font-bold text-brand-burgundy" style={{
        fontSize: 'clamp(1.95rem, 8vw, 4.5rem)',
        lineHeight: 1.02,
        letterSpacing: '-0.02em'
      }} data-id="element-107" data-mp="161ay3ae1l63f">
          <span className="block whitespace-nowrap" data-id="element-108" data-mp="x0uxc8oood29">
            Lezioni più{' '}
            <span className="relative inline-block" data-id="element-109" data-mp="3ltqclcptivti">
              <span aria-hidden="true" className="absolute inset-x-[-4px] bottom-[0.08em] h-[0.26em] bg-brand-goldLight/60" data-id="element-110" data-mp="3hrllolqr8dak" />
              <span className="relative" data-id="element-111" data-mp="1x7853o1s1ru4">chiare</span>
            </span>
          </span>
          <span className="block whitespace-nowrap" data-id="element-112" data-mp="21b64lzv0l4np">e senza improvvisare.</span>
        </h1>

        <p className="mx-auto max-w-[34ch] shrink-0 font-display font-medium italic text-brand-textLight" style={{
        fontSize: '22px',
        lineHeight: 1.2,
        paddingBottom: '41px'
      }} data-id="element-113" data-mp="268g468c4awp9">
          La conoscenza ce l’hai già. Ora puoi trasformarla in lezioni
          organizzate e pronte da guidare.
        </p>

        {/* Mockup with a luminous gold halo */}
        <div className="relative w-full min-h-0 flex-1 max-h-[42svh] flex items-center justify-center sm:max-w-xl sm:max-h-[46svh] md:max-w-[44rem] md:flex-none md:h-[40vh] md:max-h-none" data-id="element-114" data-mp="2p1jvhn1v4xgp">
          <span aria-hidden="true" className="pointer-events-none absolute inset-[12%] -z-10 rounded-full bg-brand-goldLight/20 blur-2xl" data-id="element-115" data-mp="unj0jd9foulw" />
          <img src={heroImage.src} alt={heroImage.alt} className="h-full w-full object-contain object-top gold-glow" draggable={false} decoding="async" data-id="element-116" data-mp="4b48dwosual1" />
        </div>

        <div className="flex w-full shrink-0 flex-col items-center gap-2.5 md:gap-3.5" data-id="element-117" data-mp="e88ww364ai50">
          <CTAButton variant="purple" href={CHECKOUT_URL} className="w-auto max-w-full rounded-sm cta-shimmer relative overflow-hidden font-seal px-6 py-3 text-[14px] md:text-[16px] tracking-[0.08em] font-bold" data-id="element-118" data-mp="9bihzj61tsl6">
            <span className="relative z-10" data-id="element-119" data-mp="3rg3ldrql2y6a">
              Scopri il Mega Pack — {PRICE_EUR}
            </span>
          </CTAButton>

          <div className="flex flex-col items-center gap-1.5 text-[13px] md:text-sm font-medium text-brand-muted" data-id="element-120" data-mp="3moc3s6peo2sa">
            <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5" data-id="element-121" data-mp="2yyhq5mx9ia6z">
              {trustRowOne.map(({
              icon: Icon,
              label
            }) => <li key={label} className="inline-flex items-center gap-1.5" data-id="element-122" data-mp="19ixbbwxsbc90">
                  <Icon className="w-3.5 h-3.5 text-brand-muted/80 shrink-0" data-id="element-123" data-mp="19gub6k2x42qk" />
                  {label}
                </li>)}
            </ul>
            <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5" data-id="element-124" data-mp="zliys8ezf7lz">
              {trustRowTwo.map(({
              icon: Icon,
              label
            }) => <li key={label} className="inline-flex items-center gap-1.5" data-id="element-125" data-mp="1s959s1qjheiv">
                  <Icon className="w-3.5 h-3.5 text-brand-muted/80 shrink-0" data-id="element-126" data-mp="1s729movoa50f" />
                  {label}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto max-w-[38ch] shrink-0 font-display font-semibold text-brand-purpleDark text-[17px] leading-snug sm:text-lg md:text-xl" data-id="element-127" data-mp="1j873tdwjiwxn">
          Un sistema pratico e visuale per istruttori di Tai Chi, Qi Gong e Chi
          Kung. 🧘
        </p>
      </motion.div>
    </header>;
};